import Footer from 'components/ui/Footer';
import React from 'react';
import { Link } from 'react-router-dom';
import Pricing from '../subscription-plans/components/Pricing';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* Hero */}
      <header className="bg-white">
        <div className="max-w-7xl mx-auto px-6 py-16 flex flex-col-reverse lg:flex-row items-center gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight">
              Grow your car wash business with JustBooked
            </h1>
            <p className="mt-4 text-lg text-gray-600">
              Smart bookings, secure vehicle collection, employee scheduling, and real-time analytics — all in one place.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/sign-up"
                className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-indigo-600 text-white text-sm font-medium shadow hover:bg-indigo-700"
              >
                Get Started — Free
              </Link>
              <Link
                to="/contact-us"
                className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-indigo-200 text-indigo-600 text-sm font-medium hover:bg-indigo-50"
              >
                Request a Demo
              </Link>
            </div>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-600">
              <li className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-indigo-50 text-indigo-600 font-semibold">✓</span>
                Instant online bookings
              </li>
              <li className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-indigo-50 text-indigo-600 font-semibold">✓</span>
                Secure vehicle collection
              </li>
              <li className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-indigo-50 text-indigo-600 font-semibold">✓</span>
                Manage staff & shifts
              </li>
              <li className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-indigo-50 text-indigo-600 font-semibold">✓</span>
                Real-time performance dashboards
              </li>
            </ul>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="w-full max-w-md bg-gradient-to-br from-indigo-50 to-white rounded-2xl shadow-lg p-6">
              {/* mock app preview */}
              <div className="h-80 bg-white rounded-xl border border-gray-100 overflow-hidden flex flex-col">
                <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
                  <div className="text-sm font-medium text-gray-700">JustBooked</div>
                  <div className="text-xs text-gray-400">Preview</div>
                </div>
                <div className="p-6 flex-1 overflow-auto">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-3">
                      <div className="h-6 bg-gray-100 rounded w-24" />
                      <div className="h-10 bg-indigo-50 rounded" />
                      <div className="h-16 bg-gray-50 rounded border border-gray-100" />
                    </div>
                    <div className="space-y-3">
                      <div className="h-6 bg-gray-100 rounded w-20" />
                      <div className="h-10 bg-indigo-600 rounded" />
                      <div className="h-16 bg-gray-50 rounded border border-gray-100" />
                    </div>
                  </div>
                </div>
                <div className="px-5 py-4 border-t border-gray-100 text-xs text-gray-500">Works on desktop & mobile</div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Features */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-2xl font-bold text-gray-900">Everything your car wash needs</h2>
          <p className="mt-2 text-gray-600 max-w-2xl">From bookings to billing — tools built for car wash owners to save time and increase revenue.</p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="font-semibold text-gray-900">Online Booking</h3>
              <p className="mt-2 text-sm text-gray-600">Allow customers to book services online with ease.</p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="font-semibold text-gray-900">Secure Vehicle Collection</h3>
              <p className="mt-2 text-sm text-gray-600">Ensure vehicles are collected securely and on time.</p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="font-semibold text-gray-900">Staff Management</h3>
              <p className="mt-2 text-sm text-gray-600">Create shifts, assign roles, and track time.</p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="font-semibold text-gray-900">Insightful Reports</h3>
              <p className="mt-2 text-sm text-gray-600">Daily operations and revenue analytics at a glance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing / CTA */}
      <Pricing />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;
